import { drilldownDataCorporate, ModuleFields } from "~/Utils/drilldownDataDum";

export const mapFields = (data: ModuleFields[]) => {
  return data.map(({ fieldName, placeholder, name, formType, validation, className, hidden, usedFileType }) => ({
    name,
    type: formType,
    label: fieldName,
    placeholder,
    validation,
    className,
    hidden,
    usedFileType
  }));
};

let fields: any = {};

const fieldsReady = new Promise(async (resolve, reject) => {
  try {
    const data = await drilldownDataCorporate();
    console.log("constantdatadum", data);
    fields = {
      subsidiaries: data?.subsidiaries?.map((data: ModuleFields[])=>{
        return mapFields(data);
      }),
      nextPageSubsidiaries: mapFields(data?.nextPageSubsidiaries)
    };
    resolve(fields); 
  } catch (error) {
    console.error("Error accessing drilldown data:", error);
    reject(error); 
  }
});

export { fields, fieldsReady };
